import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsAnalyticsDataViewListRoute: InvariantJiraRoute = {
	name: 'assets-analytics-data-view-list',
	path: '/jira/assets/analytics/data-view',
	exact: true,
};
